<script setup lang="ts">
import { computed } from 'vue';

import { useI18n, useTheme } from '@thehotelsnetwork/widgets-core';
import type { HotelType, TopPercentType } from '@thehotelsnetwork/personalization-types';

const props = withDefaults(
  defineProps<{
    config: {
      orLocName?: string;
      hotelGeoname?: string;
      hotelLocation?: string;
      topPercentType: TopPercentType;
      topPercent: number;
      hotelType: HotelType;
    }
    hightlightColor?: string;
    fontSize?: 'small' | 'large';
  }>(),
  {
    fontSize: 'small',
  },
);
const { t } = useI18n();
const theme = useTheme();

const propertyLocation = computed(() => (
  props.config.orLocName
  || props.config.hotelGeoname
  || props.config.hotelLocation));

const showPositionPercent = computed(() => (
  !props.config.topPercentType
  || props.config.topPercentType !== 2
));
const hotelTypeString = computed(() => {
  switch (props.config.hotelType) {
    case 2:
      return t('Resorts');
    case 3:
      return t('B&Bs');
    case 4:
      return t('Apartments');
    case 5:
      return t('Campsites');
    default:
      return t('Hotels');
  }
});
const hightlightColor = computed(() => (
  props.hightlightColor ?? theme.actionColor.base
));
</script>

<template>
  <p
    :class="[
      'propertyRating text-center leading-4',
      props.fontSize === 'large' ? 'text-lg' : 'text-sm',
    ]"
    v-html="t(
      '<em>TOP {position}</em> {hotelType} in {location}',
      {
        position: `${props.config.topPercent}${showPositionPercent ? '%' : ''}`,
        hotelType: hotelTypeString,
        location: propertyLocation || '',
      },
    )"
  />
</template>

<style scoped>
.propertyRating :deep(em){
  color: v-bind('hightlightColor');
  font-weight: 500;
  font-style: normal;
}
</style>
